import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Private' },
    { value: 2, label: 'School' },
    { value: 3, label: 'Public' },
  ],
});
